enum GeneralCodesEnum {
  AddressStreetMaxChars = 'GEN_ADDRESS_STREET_MAX_CHARS',
  MaxAddressAdditionalStreetMaxChars = 'GEN_ADDRESS_ADDITIONAL_STREET_MAX_CHARS',
  AddressZipcodeMaxChars = 'GEN_ADDRESS_ZIPCODE_MAX_CHARS',
  AddressCityAutocompleteMinChars = 'GEN_ADDRESS_CITY_AUTOCOMPLETE_MIN_CHARS',
  AddressCityOptionsMaxCount = 'GEN_ADDRESS_CITY_OPTIONS_MAX_COUNT',
  AutocompleteMinChars = 'GEN_AUTOCOMPLETE_MIN_CHARS',
  NotificationCvVideoStatus = 'GEN_NOTIFICATION_CV_VIDEO_STATUS',
  NotificationApplicationStatus = 'GEN_NOTIFICATION_APPLICATION_STATUS',
  NotificationJobStatus = 'GEN_NOTIFICATION_JOB_STATUS',
}

export default GeneralCodesEnum;
